<!-- 任务分派（巡检任务分派、工单任务分派） -->
<template>
  <j-modal :title="title" v-dragModal :width="1000" :visible="visible" :confirmLoading="confirmLoading"
    :maskClosable="false" :body-style="{ height: '480px', overflow: 'hidden', overflowY: 'scroll' }" @ok="handleOk"
    @cancel="handleCancel" :okText="$t('确定')" :cancelText="$t('关闭')" :okButtonProps="{ class:{'jee-hidden': disableSubmit} }">
    <a-spin :spinning="confirmLoading">
      <j-form-container>
        <a-form-model ref="form" :model="model" :rules="validatorRules" slot="detail" :colon="false">
          <a-row :gutter="24">
            <a-col :span="8">
              <a-form-model-item :label="$t('巡检状态')" prop="ticketsType">
                <a-select v-model="model.ticketsType">
                  <a-select-option :value="0">{{ $t('换表') }}</a-select-option>
                </a-select>
              </a-form-model-item>
            </a-col>
            <a-col :span="8">
              <a-form-model-item :label="$t('任务状态')" prop="ticketsNum">
                <a-select v-model="model.ticketsType">
                  <a-select-option :value="0">{{ $t('换表') }}</a-select-option>
                </a-select>
              </a-form-model-item>
            </a-col>
            <a-col :span="8">
              <a-form-model-item :label="$t('选择实施人')" prop="ticketsLocation">
                <a-radio-group v-model="model.fk">
                  <a-radio :value="1">{{ $t('指定班组') }}</a-radio>
                  <a-radio :value="0">{{ $t('直接指定实施人员') }}</a-radio>
                </a-radio-group>
              </a-form-model-item>
            </a-col>
            <a-col :span="8">
              <a-form-model-item :label="$t('选择班组')" prop="ticketsContactPhone">
                <a-select v-model="model.ticketsType">
                  <a-select-option :value="0">{{ $t('换表') }}</a-select-option>
                </a-select>
              </a-form-model-item>
            </a-col>
            <a-col :span="24">
              <a-form-model-item :label="$t('备注')" prop="remark">
                <a-textarea v-model="model.remark" :placeholder="$t('请输入备注信息')" :rows="4" />
              </a-form-model-item>
            </a-col>
          </a-row>
        </a-form-model>
      </j-form-container>
    </a-spin>
  </j-modal>
</template>

<script>
  import {
    JeecgListMixin
  } from '@/mixins/JeecgListMixin';
  import {
    httpAction,
    getAction
  } from '@/api/manage'
  import {
    validateDuplicateValue
  } from '@/utils/util'
  export default {
    mixins: [JeecgListMixin],
    name: 'taskAllocationModal',
    components: {},
    data() {
      return {
        title: '',
        width: 800,
        visible: false,
        disableSubmit: false,
        confirmLoading: false,
        model: {},
        url: {
          add: "/jeecg-engineering/ticket/tickets/add",
          edit: "/jeecg-engineering/ticket/tickets/edit",
          queryById: "/jeecg-engineering/ticket/tickets/queryById",
          list: "/jeecg-charge/meter/meterUserinfo/list",
          flowlist: "/jeecg-engineering/flowable/definition/list",
          meterInfo: "/jeecg-charge/meter/meterUserinfo/queryUserDetailInfoById"
        },
      }
    },
    computed: {
      validatorRules() {
        return {
          ticketsType: [{required:true,message:this.$t('请选择工单类型'),trigger:'change'}],
          ticketsLocation: [{required:true,message:this.$t('请输入地理信息'),trigger:'blur'}],
          ticketsContact: [{required:true,message:this.$t('请输入工单联系人'),trigger:'blur'}],
          ticketsContactPhone: [{required:true,message:this.$t('请输入联系电话'),trigger:'blur'}],
          ticketsEmergency: [{required:true,message:this.$t('请输入紧急程度'),trigger:'blur'}],
          ticketsDeadline: [{required:true,message:this.$t('请选择截止时间'),trigger:'change'}],
          ticketsTransaction: [{required:true,message:this.$t('请输入事务分类'),trigger:'blur'}],
        }
      }
    },
    methods: {
      add() {
        this.visible = true;
        this.model = {};
      },
      edit(record) {
        this.visible = true;
        this.model = JSON.parse(JSON.stringify(record));
      },
      close() {
        this.$emit('close');
        this.visible = false;
      },
      handleOk() {
        const that = this;
        // 触发表单验证
        this.$refs.form.validate(valid => {
          if (valid) {
            that.confirmLoading = true;
            let httpurl = '';
            let method = '';
            if (!this.model.id) {
              httpurl += this.url.add;
              method = 'post';
            } else {
              httpurl += this.url.edit;
              method = 'put';
            }
            httpAction(httpurl, this.model, method).then((res) => {
              if (res.success) {
                that.$message.success(res.message);
                that.$emit('ok');
                this.visible = false;
              } else {
                that.$message.warning(res.message);
              }
            }).finally(() => {
              that.confirmLoading = false;
            })
          }

        })
      },
      handleCancel() {
        this.close()
      },
    }
  }
</script>